import { useState } from 'react';
import './TrademarkApplicationsListItem.css';
import { capitalizeFirstLetter } from '../../utilities/services/capitalizeFirstLetter';
import { Link } from 'react-router-dom';

export default function TrademarkApplicationsListItem({user, applicationItem, updateApplications, trademarkApplicationPreferences, isMobile, toggleNotifications}) {
    const noteLimit = 10
    const [showMoreNote, setShowMoreNote] = useState(false)
    const handleShowMoreNote = () => {
        setShowMoreNote(!showMoreNote)
    }

    return (
    <tr className={`TrademarkApplicationsListItem ${applicationItem.applicationStatus? applicationItem.applicationStatus:''}`}>
        {!trademarkApplicationPreferences.includes('RPNumber') &&
        <td className='RPNumber'>
            {applicationItem.RPNumber? 
            <Link to={`/applications/trademark/${applicationItem._id}`}>
                {applicationItem.RPNumber}
            </Link>
            :
            '---'
            }
        </td>
        }
        {!trademarkApplicationPreferences.includes('applicationNumber') &&
        <td className='applicationNumber'>
            {applicationItem.applicationNumber? applicationItem.applicationNumber:'---'}
        </td>
        }
        {!trademarkApplicationPreferences.includes('applicationType') &&
        <td className='applicationType'>
            {applicationItem.applicationType? capitalizeFirstLetter(applicationItem.applicationType):'---'}
        </td>
        }
        {!trademarkApplicationPreferences.includes('trademarkType') &&
        <td className='trademarkType'>
            {applicationItem.trademarkType? capitalizeFirstLetter(applicationItem.trademarkType):'---'}
        </td>
        }
        {!trademarkApplicationPreferences.includes('filingDate') &&
        <td className='filingDate dateField'>
            <div>
                {applicationItem.filingDate? new Date(applicationItem.filingDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}
            </div>
        </td>
        }
        {!trademarkApplicationPreferences.includes('trademarkDescription') &&
        <td className='trademarkDescription'>
            <div>
                {applicationItem.trademarkDescription? applicationItem.trademarkDescription:'---'}
            </div>
        </td>
        }
        {!trademarkApplicationPreferences.includes('applicationStatus') &&
        <td className='applicationStatus'>
            <div>
                {applicationItem.applicationStatus? 
                <>
                {applicationItem.applicationStatus === 'officeActionIssued'? 'Office Action Issued' : applicationItem.applicationStatus === 'awaitingExam'? 'Awaiting Examination' : applicationItem.applicationStatus === 'examReportIssued'? 'Examination Report Issued' : applicationItem.applicationStatus === 'NOAIssued'? 'NOA Issued' : capitalizeFirstLetter(applicationItem.applicationStatus)}
                </>
                :
                '---'
                }
            </div>
        </td>
        }
        {!trademarkApplicationPreferences.includes('trademarkClasses') &&
        <td className='trademarkClasses'>
            {applicationItem.trademarkClasses? applicationItem.trademarkClasses:'---'}
        </td>
        }
        {!trademarkApplicationPreferences.includes('clientName') &&
        <td className='clientName'>
            {applicationItem.clientName? capitalizeFirstLetter(applicationItem.clientName):'---'}
        </td>
        }
        {!trademarkApplicationPreferences.includes('clientID') &&
        <td className='clientID'>
            {applicationItem.clientID? applicationItem.clientID:'---'}
        </td>
        }
        {!trademarkApplicationPreferences.includes('filingFirm') &&
        <td className='filingFirm'>
            {applicationItem.filingFirm? capitalizeFirstLetter(applicationItem.filingFirm):'---'}
        </td>
        }
        {!trademarkApplicationPreferences.includes('firmRefNumber') &&
        <td className='firmRefNumber'>
            {applicationItem.firmRefNumber? applicationItem.firmRefNumber:'---'}
        </td>
        }
        {!trademarkApplicationPreferences.includes('contact') &&
        <td className='contact'>
            {applicationItem.contact? capitalizeFirstLetter(applicationItem.contact):'---'}
        </td>
        }
        {!trademarkApplicationPreferences.includes('applicants') &&
        <td className='applicants'>
            {applicationItem.applicants? capitalizeFirstLetter(applicationItem.applicants):'---'}
        </td>
        }
        {!trademarkApplicationPreferences.includes('applicantAddress') &&
        <td className='applicantAddress'>
            {applicationItem.applicantAddress? applicationItem.applicantAddress:'---'}
        </td>
        }
        {!trademarkApplicationPreferences.includes('highlyRelevantTrademarkClass') &&
        <td className='highlyRelevantTrademarkClass'>
            {applicationItem.highlyRelevantTrademarkClass? applicationItem.highlyRelevantTrademarkClass:'---'}
        </td>
        }
        {!trademarkApplicationPreferences.includes('filing') &&
        <td className='filing'>
            {applicationItem.filing? 
            <>
            {applicationItem.filing === 'useInCommerce' ? 'Use In Commerce' : applicationItem.filing === 'intentToUse' ? 'Intent To Use' : applicationItem.filing === 'baseApplication' ? 'Base Application' : applicationItem.filing === 'foreignPriority' ? 'Foreign Priority' : applicationItem.filing === 'foreignRegistration' ? 'Foreign Registration' : applicationItem.filing === 'internationalFiling' ? 'International Filing' : capitalizeFirstLetter(applicationItem.filing)}
            </>
            :
            '---'
            }
        </td>
        }
        {!trademarkApplicationPreferences.includes('priorityDate') &&
        <td className='priorityDate dateField'>
            {applicationItem.priorityDate? new Date(applicationItem.priorityDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}
        </td>
        }
        {!trademarkApplicationPreferences.includes('priorityApplication') &&
        <td className='priorityApplication'>
            {applicationItem.priorityApplication? applicationItem.priorityApplication:'---'}
        </td>
        }
        {!trademarkApplicationPreferences.includes('registrationNumber') &&
        <td className='registrationNumber'>
            <div>
                {applicationItem.registrationNumber? applicationItem.registrationNumber:'---'}
            </div>
        </td>
        }
        {!trademarkApplicationPreferences.includes('feesPaid') &&
        <td className='feesPaid'>
            <div>
                {applicationItem.feesPaid? capitalizeFirstLetter(applicationItem.feesPaid):'---'}
            </div>
        </td>
        }
        {!trademarkApplicationPreferences.includes('registrationDate') &&
        <td className='registrationDate dateField'>
            <div>
                {applicationItem.registrationDate? new Date(applicationItem.registrationDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}
            </div>
        </td>
        }
        {!trademarkApplicationPreferences.includes('nationalEntryDate') &&
        <td className='nationalEntryDate dateField'>
            <div>
                {applicationItem.nationalEntryDate? new Date(applicationItem.nationalEntryDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}
            </div>
        </td>
        }
        {!trademarkApplicationPreferences.includes('examinationByOffice') &&
        <td className='examinationByOffice'>
            <div>
                {applicationItem.examinationByOffice? capitalizeFirstLetter(applicationItem.examinationByOffice):'---'}
            </div>
        </td>
        }
        {!trademarkApplicationPreferences.includes('approvalOrDenial') &&
        <td className='approvalOrDenial'>
            <div>
                {applicationItem.approvalOrDenial? capitalizeFirstLetter(applicationItem.approvalOrDenial):'---'}
            </div>
        </td>
        }
        {!trademarkApplicationPreferences.includes('NOA') &&
        <td className='NOA'>
            {applicationItem.NOA? capitalizeFirstLetter(applicationItem.NOA):'---'}
        </td>
        }
        {!trademarkApplicationPreferences.includes('maintenanceOfRegistration') &&
        <td className='maintenanceOfRegistration'>
            <div>
                {applicationItem.maintenanceOfRegistration? capitalizeFirstLetter(applicationItem.maintenanceOfRegistration):'---'}
            </div>
        </td>
        }
        {!trademarkApplicationPreferences.includes('lastAction') &&
        <td className='lastAction'>
            {applicationItem.lastAction? applicationItem.lastAction:'---'}
        </td>
        }
        {!trademarkApplicationPreferences.includes('nextAction') &&
        <td className='nextAction'>
            <div>
                {applicationItem.nextAction? applicationItem.nextAction:'---'}
            </div>
        </td>
        }
        {!trademarkApplicationPreferences.includes('nextActionDueDate') &&
        <td className='nextActionDueDate dateField'>
            <div>
                {applicationItem.nextActionDueDate? new Date(applicationItem.nextActionDueDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}
            </div>
        </td>
        }
        {!trademarkApplicationPreferences.includes('notes') &&
        <td className='notes'>
            <div>
                { showMoreNote ? 
                <>
                <span>{applicationItem.note? `${applicationItem.note}` : '---'}</span>
                { applicationItem.note && applicationItem.note.length > noteLimit &&
                <>
                <span>&nbsp;</span>
                <span className='limitText' onClick={handleShowMoreNote}>View Less</span>
                </>
                }
                </>
                : 
                <>
                <span>{applicationItem.note? `${applicationItem.note.substring(0, noteLimit)}`: '---'}</span>
                { applicationItem.note && applicationItem.note.length > noteLimit &&
                <>
                <span className='primaryText'>&nbsp;...</span>
                <span className='limitText' onClick={handleShowMoreNote}>View More</span>
                </>
                }
                </>
                }
            </div>
        </td>
        }
        {!trademarkApplicationPreferences.includes('trademarkClassesForSearch') &&
        <td className='trademarkClassesForSearch'>
            {applicationItem.trademarkClassesForSearch? applicationItem.trademarkClassesForSearch:'---'}
        </td>
        }
        {!trademarkApplicationPreferences.includes('trademarkClassesForFiling') &&
        <td className='trademarkClassesForFiling'>
            <div>
                {applicationItem.trademarkClassesForFiling? applicationItem.trademarkClassesForFiling:'---'}
            </div>
        </td>
        }
        {!trademarkApplicationPreferences.includes('driveFolderLocation') &&
        <td className='driveFolderLocation'>
            {applicationItem.driveFolderLocation? 
            <a href={applicationItem.driveFolderLocation.trim()} rel="noreferrer" target='_blank'>
                <svg xmlns="http://www.w3.org/2000/svg" width="23" fill="currentColor" className="bi bi-link-45deg" viewBox="0 0 16 16">
                    <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1 1 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4 4 0 0 1-.128-1.287z"/>
                    <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243z"/>
                </svg>
            </a>
            :
            '---'
            }
        </td>
        }
        {!trademarkApplicationPreferences.includes('createdAt') &&
        <td className='createdAt dateField'>
            <div>
                {applicationItem.createdAt? new Date(applicationItem.createdAt).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}
            </div>
        </td>
        }
        {!trademarkApplicationPreferences.includes('updatedAt') &&
        <td className='updatedAt dateField'>
            <div>
                {applicationItem.updatedAt? new Date(applicationItem.updatedAt).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}
            </div>
        </td>
        }
    </tr>
  )
}
